import { createBillingLaywer, getBillingLaywer, updateInfoBillingLaywer,createFingerprintStripe, updateStatusMembership
} from '../../configs/environments/firebase/firebaseApp'
import axios from 'axios';
import { batch } from 'react-redux'

export const BILLING_LAYWERS = 'BILLING_LAYWERS'
export const CREATED_CARD = 'CREATED_CARD'




const billingLaywerAdd = (data) => {
    return {
        type: BILLING_LAYWERS,
        data
    }
}

const createdCard = (data) => {
 
    return {
        type: CREATED_CARD,
        data
    }
}

export const createFingerprint = (lawyerUid, data) => (dispatch) =>{
    process_createFingerprint(dispatch, lawyerUid, data)
}

export const createBillingLaywers =  (lawyerUid, data,setFieldError) => (dispatch) =>{
    return new Promise((resolve, reject) => {
        let phone =  data.invoicePhoneNumber !="" ||data.invoicePhoneNumber !=undefined ? data.invoicePhoneNumber :'';
        let errorClient ='';
        let errorCard;
        let info  =JSON.stringify({"stripe": {
            "name": data.nameLawyerOrLawFirm,
            "email":data.invoiceEmail,
            "phone":phone,
                "address":{
                    "line1": data.street,
                    "city": data.city,
                    "state":data.states,
                    "postal_code":`${data.zipCode == undefined ? "" : data.zipCode}`,
                    "country":"MX"},
                "tax_id_data":[{
                    "type":"mx_rfc",
                    "value":data.rfc
                }]},
            "factura":{
                "legal_name": data.nameLawyerOrLawFirm,
                "tax_id": data.rfc,
                "email":data.invoiceEmail,
                "phone":phone,
                "address":{
                    "street": data.street,
                    "exterior":data.outdoorNumber,
                    "interior":"",
                    "neighborhood":data.states,
                    "zip":`${data.zipCode == undefined ? "" : data.zipCode}`,
                    "country":"MEX"
                }
            }
        })

       
         axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createClient`, info, {
                headers: {
                  'Content-Type': 'application/json',
                  "Access-Control-Allow-Origin": "*",
                  'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                }
              }
              ).then(function (response) {
             

                 let wholeData= {}
                        if(data.zipCode == undefined || data.zipCode== ''){
                            wholeData={
                                ...data,
                                city: "",
                                invoicePhoneNumber: data.invoicePhoneNumber == undefined ? '':data.invoicePhoneNumber ,
                                municipality: "",
                                neighborhood: "",
                                outdoorNumber: "",
                                states: "",
                                street: "",
                                zipCode: ""
                            }
                        }else{
                            wholeData={
                                ...data,
                                invoicePhoneNumber:data.invoicePhoneNumber == undefined ? '':data.invoicePhoneNumber ,
    
                            }
                        }
                createBillingLaywer(lawyerUid, {idStripe:response.data.idStripe, idFacturapi:response.data.idInvoice, ...wholeData})

                batch(() => {
              dispatch(billingLaywerAdd( {idStripe:response.data.idStripe, idFacturapi:response.data.idInvoice, ...wholeData})) 
            })
              }) 
              .catch(function (error) {                
                if (error.response) {
                  
                    if(error.response.data){
    
                        switch(error.response.data.error.code){
                            case "tax_id_invalid":
                              
                                errorClient ='RFC Invalido' 
                                break;
                            case "email_invalid":
                                errorClient ='Correo' 
                                break;
                            case "rate_limit":    
                            default: errorClient = "Error"
                               
                                break;
                        } 
          
                    } else if (error.request) {
                       
                    } else {
                      
                    }
                }
                setFieldError("rfc",errorClient)
              });
    })
}

export const createStatusMembership = (lawyerUid,) => (dispatch) =>{
    process_statusMembership_laywer(dispatch, lawyerUid,)
}


export const updateBillingLaywers = (lawyerUid, data) => (dispatch) =>{
    dispatch(billingLaywerAdd(data))
}


export const getBillingLaywers = (lawyerUid) => (dispatch) => {
    process_get_billing_laywer(dispatch, lawyerUid)
}

async function process_statusMembership_laywer (dispatch, lawyerUid){
    try { 
        updateStatusMembership(lawyerUid)
            .then(res=>{
                return res
                dispatch()
            })
            .catch(err=>{
                return err
                dispatch()
            })
    } catch (error) {
        dispatch()
    }
}



async function process_createFingerprint (dispatch, lawyerUid, data ){
    try { 
        createFingerprintStripe(lawyerUid, data)
            .then(res=>{
                return res
                
            })
            .catch(err=>{
                return err
               
            })
    } catch (error) {
        dispatch()
    }
}



async function process_billing_laywer (dispatch, lawyerUid, data ,membershipData){
    
}



export const createCard = (lawyerUid, data) => (dispatch) =>{
    process_createCard(dispatch, lawyerUid, data)
}


async function process_createCard (dispatch, idStripe, data){
    try {
       

        let info = {
            "number":"5555555555554444",
            "month": 2,
            "year": 2023,
            "cvc": "675",
            "currency":"mxn",
            "country":"México"
        }
        
        await axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createToken`, info, {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
            }
          }
          ).then(function (response) {
            if(response.data.id != null){
                axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createCardByClientn`, {
                    "clientId": idStripe,
                    "tokenCard":  response.data.id
                   
                }, {
                        headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*",
                        'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                        }
                    }
                    ).then(function (response) {
                        if(response.data.id != null){
                            dispatch(createdCard( {idStripe:response.data.id, ...data}))
                        }
                    }) 
                        .catch(function (response) {
                        }); 

            }
          }) 
            .catch(function (response) {
            }); 

            
       
    } catch (error) {
        
    }
}

async function process_get_billing_laywer (dispatch,lawyerUid){
    let data = await getBillingLaywer(lawyerUid);
    dispatch(billingLaywerAdd(data))
}
